import * as z from "zod";
//#region src/__generated__/models/modelJobStatuses/zod/jobStatusDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const jobStatusDtoSchema = z.object({
	id: z.uuid().nullish(),
	outputFormat: z.enum([
		"PROPERTIES",
		"GEOMETRY",
		"COMPARE",
		"MEASURE_RESULT",
		"COLLISION",
		"MULTY_COLLISION",
		"CONVERTING"
	]).optional().describe("Формат данных, которые будут получены после выполнения задания"),
	state: z.enum([
		"waiting",
		"running",
		"done",
		"failed",
		"all",
		"WAITING",
		"RUNNING",
		"DONE",
		"FAILED",
		"ALL"
	]).optional().describe("Состояние задания"),
	statusMessage: z.string().nullish().describe("Комментарий к состоянию задания")
});
//#endregion
//#region src/__generated__/models/modelJobStatuses/zod/modelSoftwareInfoDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelSoftwareInfoDtoSchema = z.object({
	createdAt: z.iso.datetime().nullish(),
	fileCreatedAt: z.iso.datetime(),
	id: z.uuid().nullish().describe("Идентификатор записи"),
	metadataJson: z.string().nullish(),
	modelId: z.uuid().nullish(),
	platformIdentifier: z.string(),
	softwareName: z.string(),
	softwareVersion: z.string()
});
//#endregion
//#region src/__generated__/models/modelJobStatuses/zod/modelStatusDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelStatusDtoSchema = z.object({
	jobs: z.array(jobStatusDtoSchema).nullish(),
	modelId: z.uuid().nullish(),
	modelSoftwareInfoDto: z.union([modelSoftwareInfoDtoSchema, z.null()]).optional()
});
//#endregion
//#region src/__generated__/models/modelJobStatuses/zod/modelStatusRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelStatusRequestDtoSchema = z.object({ modelIds: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/models/modelJobStatuses/zod/getStatusSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getStatusStatus200Schema = z.array(modelStatusDtoSchema);
const getStatusResponseSchema = getStatusStatus200Schema;
const getStatusDataSchema = modelStatusRequestDtoSchema;
//#endregion
export { modelStatusDtoSchema as a, modelStatusRequestDtoSchema as i, getStatusResponseSchema as n, modelSoftwareInfoDtoSchema as o, getStatusStatus200Schema as r, jobStatusDtoSchema as s, getStatusDataSchema as t };

//# sourceMappingURL=getStatusSchema.js.map